// industryColorMap.js
const industryColorMap = {
    "Fast Moving Consumer Goods": "bg-slate-700",
    "Capital Goods": "bg-gray-600",
    "Healthcare": "bg-zinc-700",
    "Chemicals": "bg-neutral-600",
    "Financial Services": "bg-stone-700",
    "Metals & Mining": "bg-red-700",
    "Consumer Durables": "bg-orange-700",
    "Oil Gas & Consumable Fuels": "bg-amber-700",
    "Automobile and Auto Components": "bg-yellow-700",
    "Services": "bg-lime-700",
    "Construction": "bg-green-700",
    "Realty": "bg-emerald-700",
    "Information Technology": "bg-teal-700",
    "Media Entertainment & Publication": "bg-cyan-700",
    "Power": "bg-sky-700",
    "Telecommunication": "bg-blue-700",
    "Consumer Services": "bg-indigo-700",
    "Textiles": "bg-violet-700",
    "Construction Materials": "bg-purple-700",
    "Diversified": "bg-fuchsia-700"
  };
  
  export default industryColorMap;
  